/**
商品列表
**/
<template>
  <div class="rightaside_content">
    <div class="changeTab" v-if="current != 3">
      <div v-for="(item,index) in itemTabs" :key="index" :class="current==index?'active':''"
        @click="changeIndex(index,item)">{{item}}<span class="lin"></span></div>
    </div>
    <!-- current == 0  title == '最新政策'-->
    <div class="policyList" v-if="current == 0">
      <div class="policy" v-for="(item1,index1) in articleList" :key="index1"
        @click="$router.push({path:'/siteHelpDetail',query:{itemId:item1.articleId}})">
        <div class="left">
          <span class="titleLin"></span>
          {{item1.articleTitle}}
        </div>
        <div class="time">{{item1.createTime}}</div>
      </div>
      <el-col class="noData" v-if="articleList.length==0?true:false">
        <div>暂无相关文章</div>
      </el-col>
    </div>
    <!-- current == 1 title == '新闻资讯'-->
    <div class="newsList" v-if="current == 1">

      <div class="news" v-for="(item2,index2) in  articleList" :key="index2"
        @click="$router.push({path:'/siteHelpDetail',query:{itemId:item2.articleId}})">

        <img :src="item2.articleImage">
        <div class="center">
          <span>{{item2.articleTitle}}</span>
          <span class="time">{{item2.createTime}}</span>
        </div>
      </div>
      <el-col class="noData" v-if="articleList.length==0?true:false">
        <div>暂无相关文章</div>
      </el-col>
    </div>
    <!-- current == 2 -->
    <!-- <el-row :gutter="60" v-loading='loading'>
			<el-col v-for="item in articleList" :key="item.id">
				<div class="articleItem">
					<el-row style="width: 100%;" :gutter="20">
						<el-col :span="6">
							<el-image :src="item.articleImage">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</el-col>
						<el-col :span="18">
							<div class="title OneLineDisplay">{{item.articleTitle}}</div>
							<div class="descript">
								<span><i class="el-icon-user-solid"></i> {{item.createBy}}</span>
								<span><i class="el-icon-folder"></i> {{item.name}}</span>
								<span><i class="el-icon-chat-round"></i> {{item.articleCount}}</span>
								<span><i class="el-icon-date"></i> {{item.createTime}}</span>
							</div>
							<router-link :to='`/siteHelpDetail?itemId=${item.articleId}`' class="seeMore">
								<span>查看更多</span>
							</router-link>
						</el-col>
					</el-row>

				</div>
				<el-col class="noData" v-if="articleList.length==0?true:false">
					<div>暂无相关文章</div>
				</el-col>
			</el-col>



		</el-row> -->
    <!--  title == '新闻资讯'||title == '最新政策' -->
    <el-col :span="24" class="pagination" v-if="current == 0||current == 1">
      <newPage v-bind:child-msg="pageparm" @callFather="callFather" background="#cc3528"></newPage>
      <!-- <newPage v-bind:child-msg="pageparms" @callFather="callFather" background="#cc3528" v-if="current == 1"></newPage> -->
    </el-col>
    <!-- 品牌概况  title == '品牌概况'-->
    <div class="generalizeBox" v-if="current == 2">
      <div class="generalizeCenter" v-html="articleItem.articleContent"></div>
      <el-col class="noData" v-if="!articleItem.articleContent">
        <div>暂无相关文章</div>
      </el-col>
      <!--<div class="video">
        <video-player class="video-player vjs-custom-skin"
           ref="videoPlayer"
           :playsinline="true"
           :options="playerOptions">
          </video-player>
      </div>
     <div class="licenseImg">
        <img src="../../assets/images/pc/newsEl.png" >
      </div>
      <div class="certificateList">
        <div class="certificateSon">
          <img src="../../assets/images/pc/newsEl.png" >
          <p>前进企业荣誉证书</p>
        </div>
        <div class="certificateSon">
          <img src="../../assets/images/pc/newsEl.png" >
          <p>前进企业荣誉证书</p>
        </div>
        <div class="certificateSon">
          <img src="../../assets/images/pc/newsEl.png" >
          <p>前进企业荣誉证书前进企业荣誉证书前进企业荣誉证书</p>
        </div>
        <div class="certificateSon">
          <img src="../../assets/images/pc/newsEl.png" >
          <p>前进企业荣誉证书</p>
        </div>
        <div class="certificateSon">
          <img src="../../assets/images/pc/newsEl.png" >
          <p>前进企业荣誉证书</p>
        </div>
      </div> -->

    </div>

    <!-- 常见问题 -->
    <div class="queryBox" v-if="current == 3">
      <div class="queryHdRow">
        <p class="queryHd">常见问题</p>
        <p class="returnBn" @click="changeIndex(0,'最新政策')">返回</p>
      </div>
      <div class="queryList">
        <div class="queryType" v-for="(item,index) in itemTab" :key="index" v-if="item.title == '常见问题'">
          <div v-for="(items,indexs) in item.sub_menu" :key="indexs"
            :class="queryTypeId == items.id?'queryTeSon active':'queryTeSon'" @click="queryChange(items.id)">
            <p>{{items.title}}</p>
          </div>
        </div>
        <div class="queryRContent">
          <div class="queryRow" v-for="(item, index) in queryList" :key="index">
            <div class="queryRowHd" @click="spreadShow(item.articleId)">
              <div class="queryRowL">
                <img src="../../assets/images/pc/questionIcon.png" alt="">
                <p>{{item.articleTitle}}</p>
              </div>
              <img class="moreBelow" v-if="spreadIndex == item.articleId" src="../../assets/images/pc/toDown.png"
                alt="">
              <img class="moreBelow " v-if="spreadIndex != item.articleId" src="../../assets/images/pc/toTop.png"
                alt="">
            </div>
            <!-- <div class="queryRowText" v-if="itemTab.length<1"> -->
            <div class="queryRowText" v-show="spreadIndex == item.articleId">
              <p v-html="item.articleContent"></p>
            </div>
          </div>


        </div>
      </div>
      <el-col class="noData" v-if="itemTab.length<1">
        <div>暂无相关文章</div>
      </el-col>



    </div>




  </div>
</template>
<script>
  // import { videoPlayer } from 'vue-video-player'
  // import 'video.js/dist/video-js.css'
  import newPage from '@/components/newPage'
  import {
    helpArticle_details,
    article_category_list,
    helpArticle_list
  } from '@/api/xunyou'
  export default {
    data() {
      return {
        itemTabs: ['最新政策', '新闻资讯', '品牌概况', '常见问题'],
        itemTab: [],
        policyList: [{
          title: '久久为功，稳步推进',
          time: '2022-4-12'
        }, {
          title: '好风凭借力 扬帆正当时',
          time: '2022-4-12'
        }, {
          title: '味见汉中品牌内涵极其丰富深刻发人深省',
          time: '2022-4-12'
        }],
        newsList: [{
          img: '../../assets/images/pc/newsEl.png',
          title: '久久为功，稳步推进',
          time: '2022-4-12'
        }, {
          img: 'assets/images/pc/newsEl.png',
          title: '久久为功，稳步推进',
          time: '2022-4-12'
        }, {
          img: '../../assets/images/pc/newsEl.png',
          title: '久久为功，稳步推进',
          time: '2022-4-12'
        }, {
          img: '../../assets/images/pc/newsEl.png',
          title: '久久为功，稳步推进',
          time: '2022-4-12'
        }],
        current: 0,
        title: '',
        loading: false,
        articleList: [],
        // 请求数据参数
        formInline: {
          pageSize: 10,
          pageNum: 1,
          categoryId: this.$route.query.categoryId || ''
        },
        // 分页参数
        pageparm: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        pageparms: {
          pageSize: 9,
          currentPage: 1,
          total: 0,
        },
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 如果为true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 是否视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "video/mp4", // 类型
            src: 'https://www.runoob.com/try/demo_source/mov_bbb.mp4' // url地址
          }],
          poster: '../../assets/images/pc/newsEl.png', // 封面地址
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: true, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            fullscreenToggle: true // 是否显示全屏按钮
          }
        },
        queryList: [],
        queryTypeId: 1, //问题类型Id
        spreadIndex: 0,
        articleItem: ''
      };
    },
    // 注册组件
    components: {

      newPage,
      // videoPlayer
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {},
    mounted() {
      this.getHelpArticle_list()
      this.getArticleList()
    },

    watch: {

      $route(n, o) {
        if (n.fullPath !== o.fullPath) { //监听路由参数是否变化
          this.getHelpArticle_list() //methods中封装的加载数据函数
        }
      }

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 问题展示
      spreadShow(a) {
        if (this.spreadIndex == a) {
          this.spreadIndex = 0
        } else {
          {
            this.spreadIndex = a
          }
        }
      },
      //问题类型
      queryChange(id) {
        
        this.queryTypeId = id;
        this.formInline.categoryId = id;
        helpArticle_list(this.formInline)
          .then(res => {
            if (res.code == 0) {
              this.loading = false
              this.queryList = res.rows;
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.total
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取文章列表失败，请稍后再试！')
          })

      },
      changeIndex(index, title) {
        let that = this;
        that.current = index
        that.title = title
        this.$emit('changeActive', index);
        if (index == 0 || index == 1) {
          this.formInline.pageNum = 1
          this.getHelpArticle_list()
        }
        if (title == '常见问题') {
          that.getArticleList()
        }
        if (title == '品牌概况') {
          helpArticle_details({
              articleId: 92
            })
            .then(res => {
              if (res.code == 0) {
                that.articleItem = res.data;
              } else {
                that.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              that.editFormVisible = false
              that.loading = false
              that.$message.error('获取文章详情失败，请稍后再试！')
            })

        }
      },
      // 获取分类
      getArticleList() {
        article_category_list()
          .then(res => {
            if (res.code == 0) {
              this.itemTab = res.data;
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].title == '常见问题') {
                  this.queryChange(res.data[i].sub_menu[0].id)
                }
              }
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('获取文章分类列表失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        // this.formInline.pageSize = parms.pageSize
        // this.formInline.pageNum = parm.currentPage
        // this.formInline.pageSize = parm.pageSize
        this.getHelpArticle_list()
      },
      // 文章（和公告）列表接口
      getHelpArticle_list() {
        this.loading = true
        if (this.current == 0) {
          this.formInline.pageSize = 10
        } else if (this.current == 1) {
          this.formInline.pageSize = 9
        }
        this.formInline.categoryId = this.$route.query.categoryId || ''
        helpArticle_list(this.formInline)
          .then(res => {
            if (res.code == 0) {
              this.loading = false
              this.articleList = res.rows;
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取文章列表失败，请稍后再试！')
          })

        // 获取总数
        let pageData = {
          page: 1,
          limit: 10,
          token: localStorage.getItem("logintoken"),
          categoryId: this.$route.categoryId || '',
          pageSize: ''
        }
        helpArticle_list(pageData)
          .then(res => {
            if (res.code == 0) {
              this.pageparm.total = res.total
              this.pageparm.pageSize = this.formInline.pageSize;
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })


      },
      //    //  个人信息加密
      // encryption(str, len) {
      //   if (str.length <= len) {
      //     return str;
      //   } else {
      //     var newStr = str.substring(0, 1);
      //     var newStrs = str.substring(str.length - 1, str.length - 2);
      //     newStr = newStr + "***" + newStrs;
      //     return newStr;
      //   }
      // },
    },
  };
</script>

<style scoped lang="less">
  .noData {
    text-align: center;
    height: 200px;
    line-height: 200px;
  }

  .rightaside_content {
    // background-color: #FFFFFF;

    .changeTab {
      width: 1200px;
      height: 73px;
      display: flex;
      padding: 22px 45px;
      box-sizing: border-box;
      box-shadow: inset 0 -0.83px 0 0 rgba(238, 238, 238, 1);
      background-color: #FFFFFF;

      div {
        min-width: 122.19px;
        font-size: 16.7px;
        color: #656880;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 91px;

        span {
          display: block;
          width: 33px;
          height: 4px;
          border-radius: 1px;
          background-color: #FFFFFF;
          margin-top: 3px;
        }


      }

      .active {
        font-weight: 550;
        color: #36384D;

        span {
          background-color: #CC3528;
        }
      }
    }

    .policyList {
      padding: 23px 13px;
      background-color: #FFFFFF;

      .policy {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #36384D;
        margin-top: 40px;

        .left {
          display: flex;
          align-items: center;
          font-weight: 700;

          .titleLin {
            display: block;
            width: 25px;
            height: 3px;
            background-color: #CC3528;
            margin-right: 10px;
          }
        }

        :hover {
          color: #CC3528;
        }

        .time {
          font-size: 14px;
          color: #A1A3B3;
        }


      }

      :first-child {
        margin-top: 0;
      }

    }

    .newsList {
      display: flex;
      flex-wrap: wrap;

      .news {

        background-color: #fff;
        margin: 13px 13px 0 0;

        img {
          width: 388px;
          height: 254px;
        }

        .center {
          display: flex;
          flex-direction: column;
          padding: 16px;

          span {
            font-size: 14px;
            color: #36384D;
            font-weight: 700;
          }

          .time {
            color: #A1A3B3;
            font-weight: normal;
            margin-top: 16px;
          }
        }
      }

      :nth-child(3n) {
        margin: 13px 0 0 0px;
      }
    }

    .headerTitle {
      font-size: 20px;
      height: 40px;
      line-height: 40px;
      color: #666;
    }

    i.pointNum {
      font-size: 42px;
      font-weight: 600;
    }

    .articleItem {
      display: flex;
      justify-content: start;

      .el-image {
        width: 180px;
        height: 150px;
        margin-right: 30px;
        background: #e8e8e8;

        /deep/.image-slot {
          line-height: 150px;
          text-align: center;
        }
      }

      .title {
        font-size: 18px;
        color: #666;
        margin-bottom: 5px;
      }

      .descript {
        padding: 0px 0 10px 0;
        color: #666;
        font-size: 14px;

        span {
          margin-right: 5px;
        }
      }

      .content {
        font-size: 14px;
        margin-bottom: 10px;
        height: 25px;

      }
    }

    .pagination {
      margin-top: 15px;
      text-align: center;

      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #CC3528;
        color: #FFF;
        width: 20px;
      }

      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev,
      /deep/.el-pagination.is-background .el-pager li {
        width: 20px;
      }

      /deep/input[disabled],
      input[disabled="disabled"],
      input[readonly],
      input[readonly="readonly"] {
        background-color: transparent;
      }
    }

    .generalizeBox {
      width: 1200px;
      .generalizeCenter{
            padding: 23px 13px;
    background-color: #FFFFFF;
      }
      .video {
        width: 100%;
        min-height: 456px;
        opacity: 1;
      }

      .licenseImg {
        width: 100%;
        height: 700.5px;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 1);
        margin-top: 40px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .certificateList {
        margin-top: 40px;

        .certificateSon {
          display: inline-block;
          vertical-align: top;
          width: 245px;
          height: 351px;
          opacity: 1;
          padding-bottom: 40px;
          margin: 0 20px;

          img {
            width: 245px;
            height: 309px;
          }

          p {
            width: 100%;
            color: rgba(86, 94, 111, 1);
            font-size: 16px;
            font-weight: 700;
            font-family: "OPPOSans";
            text-align: center;
            line-height: 22px;
            margin-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .certificateSon:nth-child(4n-3) {
          margin-left: 0px;
        }

        .certificateSon:nth-child(4n) {
          margin-right: 0px;
        }
      }
    }


    .queryBox {
      width: 1200px;
      text-align: left;
      padding-bottom: 40px;

      .queryHdRow {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .queryHd {
          color: rgba(0, 0, 0, 1);
          font-size: 20px;
          font-weight: 700;
          font-family: "OPPOSans";
          text-align: left;
          line-height: 28px;
          padding: 16.6px 0;
        }

        .returnBn {
          font-size: 18px;
          font-family: "OPPOSans";
          text-align: left;
          line-height: 28px;
          padding: 16.6px 0;
          color: #666;
        }
      }

      .queryList {
        width: 100%;

        .queryType {
          display: inline-block;
          vertical-align: top;
          width: 283px;
          background-color: #fff;

          .queryTeSon {
            width: 100%;
            height: 54px;
            padding: 13.3px 16.17px;
            box-sizing: border-box;
            border-bottom: 2px solid #e8e8e8;

            p {
              color: rgba(86, 94, 111, 1);
              font-size: 16px;
              font-weight: 700;
              font-family: "OPPOSans";
              text-align: left;
              line-height: 28px;
            }
          }

          .active {
            background: rgba(255, 232, 229, 1);
            box-shadow: inset -5px 0 0 0 rgba(204, 53, 40, 1);
          }

          .queryTeSon:last-child {
            border: none;
          }
        }

        .queryRContent {
          display: inline-block;
          vertical-align: top;
          width: 893px;
          min-height: 62px;
          margin-left: 20px;
          border-radius: 2px 2px 0 0;
          opacity: 1;
          background: rgba(255, 255, 255, 1);
          box-shadow: inset 0 -1px 0 0 rgba(238, 238, 238, 1);

          .queryRow {
            .queryRowHd {
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: rgba(255, 255, 255, 1);
              box-shadow: inset 0 -1px 0 0 rgba(238, 238, 238, 1);

              .queryRowL {
                img {
                  display: inline-block;
                  vertical-align: middle;
                  width: 24px;
                  height: 24px;
                  margin: 0 20px;
                }

                p {
                  display: inline-block;
                  vertical-align: middle;
                  height: 24px;
                  opacity: 1;
                  color: rgba(54, 56, 77, 1);
                  font-size: 16px;
                  font-weight: 700;
                  font-family: "OPPOSans";
                  text-align: left;
                  line-height: 22px;
                  padding: 19px 0;
                }
              }

              .moreBelow {
                width: 24px;
                height: 24px;
                margin: 0 16px;
              }
            }

            .queryRowText {
              padding: 19px 20px;
              background: rgba(255, 255, 255, 1);
              box-shadow: inset 0 -1px 0 0 rgba(238, 238, 238, 1);

              p {
                color: rgba(101, 104, 128, 1);
                font-size: 16px;
                font-weight: 500;
                font-family: "OPPOSans";
                text-align: left;
                line-height: 24px;
              }
            }

          }

          .queryRow:last-child {
            border: none;

            .queryRowHd {
              -webkit-box-shadow: inset 0 -1px 0 0 #fff;
              box-shadow: inset 0 -1px 0 0 #fff;
            }
          }
        }

      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/serviceArticle/siteHelp.vue